import { CSSProperties } from 'react';
import styled from 'styled-components';
import { Space } from './Box';

export const Spacer = styled.div<{
    y?: Space;
    x?: Space;
    t?: Space;
    b?: Space;
    l?: Space;
    r?: Space;
    flex?: CSSProperties['flex'];
    gap?: Space;
}>`
    gap: ${(props) => (props.gap ? `${props.gap}px` : 'unset')};
    display: flex;
    flex: ${(props) => props.flex ?? 'unset'};
    padding: ${(props) =>
        `${props.t ?? props.y ?? 0}px ${props.r ?? props.x ?? 0}px ${props.b ?? props.y ?? 0}px ${
            props.l ?? props.x ?? 0
        }px`};
`;
